import React, {useState, useEffect} from "react";
import useSound from "use-sound";

const images = [
    "https://media.simpleviralgames.com/images/vip-avatars/2cd294d3-c9fb-4aec-a22b-285dabd0a0fb.png",
    "https://media.simpleviralgames.com/images/vip-avatars/539e52e6-83dc-4bea-ab63-d1f964ecd90e.png",
    "https://media.simpleviralgames.com/images/vip-avatars/87e3dfb8-e453-4578-9e4a-0eb80ea2bd25.png",
    "https://media.simpleviralgames.com/images/vip-avatars/0ea424ac-b74e-49b2-b6bd-e370c7d04748.png",
    "https://media.simpleviralgames.com/images/vip-avatars/f78aed6e-6eaa-4198-ba5e-c0bff4be0770.png",
    "https://media.simpleviralgames.com/images/vip-avatars/a1dc8a04-3960-43ac-bf58-79be46423bc4.png",
    "https://media.simpleviralgames.com/images/vip-avatars/fd847d8b-3016-48a5-9cae-2e5b9bb648e4.png",
    "https://media.simpleviralgames.com/images/vip-avatars/ff519092-a70c-44d8-93ff-d1884c0b8081.png",
    "https://media.simpleviralgames.com/images/vip-avatars/c03c554a-bf8f-419a-8622-d03d4782bb87.png",
    "https://media.simpleviralgames.com/images/vip-avatars/23fc686e-8d4f-4087-a001-45799ec9e92d.png",
];
const images2 = [
    "https://media.simpleviralgames.com/images/vip-avatars/dfb8ceac-2563-4b84-97ac-48887d306d82.png",
    "https://media.simpleviralgames.com/images/vip-avatars/abe39c7d-eea8-4909-83e5-506baecf0cf0.png",
    "https://media.simpleviralgames.com/images/vip-avatars/8005386e-da34-4f51-941f-dd846102c82e.png",
    "https://media.simpleviralgames.com/images/vip-avatars/84b448b0-e27d-472e-8c67-0663f927fbaa.png",
    "https://media.simpleviralgames.com/images/vip-avatars/619f42c4-3603-44f6-b23b-a9d5e5f7f610.png",
    "https://media.simpleviralgames.com/images/vip-avatars/f1dcc22b-d284-4b96-8b52-9e0b6a2cf70e.png",
    "https://cdn.simpleviralgames.com/images/9634961b-9771-4752-bf17-440be8849276.png",
    "https://media.simpleviralgames.com/images/vip-avatars/cf8e62ca-f023-4e2d-92a1-af9dbf5463bc.png",
    "https://media.simpleviralgames.com/images/vip-avatars/d88ca9b6-e938-4bb1-b1c4-1bce03d9f695.png",
    "https://media.simpleviralgames.com/images/vip-avatars/ac095fb9-2c27-4bec-8330-7362c9be67a4.png",
];
const images3 = [
    "https://media.simpleviralgames.com/images/vip-avatars/ad125759-8656-49ff-a29f-7cec7587715b.png",
    "https://media.simpleviralgames.com/images/vip-avatars/cac927e4-dc77-4428-add3-fc5d1b269d49.png",
    "https://media.simpleviralgames.com/images/vip-avatars/db7faf62-efc1-45ca-a884-9d1c02959b21.png",
    "https://media.simpleviralgames.com/images/vip-avatars/2cdef452-970b-4c31-b0f8-0cdb5b7404b1.png",
    "https://media.simpleviralgames.com/images/vip-avatars/e7778f23-57ef-4d29-8738-111f587c4680.png",
    "https://media.simpleviralgames.com/images/vip-avatars/608ab791-fca1-4eaa-bbca-353340fdfc63.png",
    "https://media.simpleviralgames.com/images/vip-avatars/e5895f4e-8ecd-4b10-8ca1-3dd19fb04435.png",
    "https://media.simpleviralgames.com/images/vip-avatars/d1162cc3-2dca-430b-af51-452f0bf70809.png",
    "https://media.simpleviralgames.com/images/vip-avatars/720f0759-224b-45e1-8767-388054fa3eec.png",
    "https://media.simpleviralgames.com/images/vip-avatars/e89660e8-399f-493a-95f7-c1fbe40eb71a.png",
];


const ImageSlider = ({
                         finalImage,
                         startPWSGame,
                         playSound,
                         startIndex,
                         isLast,
                     }) => {
    const imagesToUse =
        startIndex === 1 ? images : startIndex === 2 ? images2 : images3;
    const [playStrangerMatchedAudio, {stop: stopStrangerMatchedAudio}] =
        useSound("/audio/stranger_matched_short.mp3", {
            volume: 1,
        });
    const [currentIndex, setCurrentIndex] = useState(startIndex);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (finalImage && playSound) {
            playStrangerMatchedAudio();
        }
        if (finalImage && isLast) {
            setTimeout(() => {
                startPWSGame();
            }, 2000);
        }
    }, [finalImage]);

    return (
        <div className={"w-[70px] md:w-[90px] overflow-hidden scrollbar-none"}>
            {!finalImage && (
                <div
                    className={
                        "w-[70px] h-[70px] md:w-[90px] md:h-[90px] overflow-y-hidden border-[5px] border-gray-400 rounded-full bg-white mx-auto"
                    }
                >
                    <div
                        className={`${startIndex % 2 === 0 ? "img-slider" : "img-slider-2"} w-[60px] h-[60px] md:w-[80px] md:h-[80px] mt-[5px] scrollbar-none`}
                        style={{
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                        }}
                    >
                        {imagesToUse.map((image, index) => (
                            <img
                                draggable={false}
                                src={image}
                                alt={`Slide ${index}`}
                                className={"w-[60px] h-[60px] md:w-[80px] md:h-[80px]"}
                                key={index}
                            />
                        ))}
                    </div>
                </div>
            )}
            {finalImage && (
                <div className={"relative"}>
                    <img
                        draggable={false}
                        src={finalImage}
                        alt={`Final Image`}
                        className={
                            "w-[60px] h-[60px] md:w-[90px] md:h-[90px] rounded-full border-5 border-white mx-auto"
                        }
                    />
                    <h1/>
                </div>
            )}
        </div>
    );
};


export default ImageSlider;
